const DISMISSED_KEY_PREFIX = 'smsr-running-low-banner-dismissed'
const SHOWN_EVENT_KEY_PREFIX = 'smsr-running-low-banner-shown'

export function canPostRunningLowShownEvent(accountId?: string, now: Date = new Date()): boolean {
  const storage = accountId ? safeSessionStorage() : null
  if (!storage) return Boolean(accountId)
  try {
    return storage.getItem(shownEventKey(accountId, now)) !== 'true'
  } catch {
    return true
  }
}

export function markRunningLowShownEventPosted(accountId?: string, now: Date = new Date()): void {
  const storage = accountId ? safeSessionStorage() : null
  if (!storage) return
  try {
    storage.setItem(shownEventKey(accountId, now), 'true')
  } catch {
    // Private-mode and quota errors are non-fatal: the event posts again.
  }
}

export function isRunningLowBannerDismissed(accountId?: string): boolean {
  const storage = accountId ? safeSessionStorage() : null
  if (!storage) return false
  try {
    return storage.getItem(`${DISMISSED_KEY_PREFIX}:${accountId}`) === 'true'
  } catch {
    return false
  }
}

export function dismissRunningLowBanner(accountId?: string): void {
  const storage = accountId ? safeSessionStorage() : null
  if (!storage) return
  try {
    storage.setItem(`${DISMISSED_KEY_PREFIX}:${accountId}`, 'true')
  } catch {
    // Private-mode and quota errors are non-fatal: the banner simply stays.
  }
}

/** A different key from the dismissal, which must not silence a later day. */
function shownEventKey(accountId: string, now: Date): string {
  return `${SHOWN_EVENT_KEY_PREFIX}:${accountId}:${now.toISOString().slice(0, 10)}`
}

/** Reading the global can itself throw where storage is blocked. */
function safeSessionStorage(): Storage | null {
  try {
    return typeof sessionStorage !== 'undefined' ? sessionStorage : null
  } catch {
    return null
  }
}
